import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import { type GlobalDateRange, useGlobalFilterStore } from '@/stores/global-filter.stores'

type LegacyDateRange = {
  start: string
  end: string
  shortcut?: number
  key?: string
  allTime?: boolean
}
const toGlobalRange = (range: LegacyDateRange): GlobalDateRange => ({
  startDate: range.start,
  endDate: range.end,
})
const toLegacyRange = (range: GlobalDateRange): LegacyDateRange => ({
  start: range.startDate,
  end: range.endDate,
})
const isSameRange = (legacy: LegacyDateRange | undefined, global: GlobalDateRange | undefined) =>
  !!legacy && !!global && legacy.start === global.startDate && legacy.end === global.endDate
export const useGlobalDateRangeSync = () => {
  const legacyStore = useStore()
  const filterStore = useGlobalFilterStore()
  const route = useRoute()
  if (filterStore.dateRange) {
    legacyStore.commit('user/UPDATE_DATA_DATE_RANGE', toLegacyRange(filterStore.dateRange))
  }
  watch(
    () => filterStore.dateRange,
    (range) => {
      const legacy = legacyStore.getters['user/dataDateRange'] as LegacyDateRange | undefined
      if (!range || isSameRange(legacy, range)) {
        return
      }
      void legacyStore.dispatch('user/updateDataDateRange', toLegacyRange(range))
    },
    { deep: true },
  )
  watch(
    () => legacyStore.getters['user/dataDateRange'] as LegacyDateRange | undefined,
    (legacy) => {
      if (!legacy || isSameRange(legacy, filterStore.dateRange)) {
        return
      }
      filterStore.setDateRange(toGlobalRange(legacy))
    },
    { deep: true },
  )
  watch(
    () => route.path,
    () => {
      filterStore.ensureDateRange()
    },
  )
}
